import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "social-media-button" }
const _hoisted_2 = ["aria-label", "href"]
const _hoisted_3 = { class: "text" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("a", {
      class: "button",
      role: "button",
      "aria-label": _ctx.$t('Link to Brenda Cayzac\'s') + ' ' + _ctx.id,
      href: _ctx.url,
      tabindex: "0"
    }, [
      _createVNode(_component_font_awesome_icon, { icon: _ctx.faIcon }, null, 8, ["icon"])
    ], 8, _hoisted_2),
    _createElementVNode("a", _hoisted_3, _toDisplayString(_ctx.text), 1)
  ]))
}